import React, { useEffect, useState } from "react";
import { Button } from "./ui/button.jsx";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card.jsx";
import { Badge } from "./ui/badge.jsx";
import { SpecimenCard } from "./SpecimenCard.jsx";
import { CreateCollectionModal } from "./CreateCollectionModal.jsx";
import { AddSpecimenModal } from "./AddSpecimenModal.jsx";
import { Plus, Archive, Beaker, Grid3X3, List, Trash2, Printer } from "lucide-react";
import { getDatos2, subespecimen, getBochones, fechaActual } from "../../store/action";
import { useSelector, useDispatch } from 'react-redux';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import styles from "./CollectionsView.module.css";
import Menu from "../NAVBAR/menu.jsx";
import { useAuth0 } from "@auth0/auth0-react";
import { url } from '../../URL.js';
import axios from 'axios';
import { useTranslation } from "react-i18next";
import { resolvePath } from "react-router-dom";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import logoMuseo from "../img/logomuseogrande.png";
import { LoadingState } from "../ui/LoadingState.jsx";



export function CollectionsView() {
  const dispatch = useDispatch();
  const [selectedCollection, setSelectedCollection] = useState({
    especimenes_detalle: [],
    bochones_detalle: [],
    especimenes: [],
    bochones: []
  });
  const [t, i18n] = useTranslation("global");
  const [collections, setCollections] = useState(null);
  const { isAuthenticated, user } = useAuth0();
  const [users, setUsers] = useState(null);
  const [percollections, setPercollections] = useState(null);
  const [isLoadingCollections, setIsLoadingCollections] = useState(true);

  const especimenes = useSelector((state) => state.especimenes);
  const bochones = useSelector((state) => state.bochones?.data);
  const espec = especimenes;
  const bochon = bochones;

  const [createCollectionOpen, setCreateCollectionOpen] = useState(false);
  const [addSpecimenOpen, setAddSpecimenOpen] = useState(false);
  const [viewLayout, setViewLayout] = useState('grid');
  const [allSpecimens, setAllSpecimens] = useState([]);
  const [combinedItems, setCombinedItems] = useState([]);
  const [sortOrder, setSortOrder] = useState('bochones'); // 'bochones' o 'especimenes'
  let [totalItems, setTotalItems] = useState(0)

  // ----- Load initial data -----
  useEffect(() => {
    dispatch(getDatos2());
    dispatch(getBochones());

    if (!user?.sub) {
      if (!isAuthenticated) setIsLoadingCollections(false);
      return;
    }

    setIsLoadingCollections(true);

    // Guardamos si user aún no llegó

    axios.get(`${url}usuariosRoute/usuario?id=` + user.sub)
      .then(resp => {
        setUsers(resp.data);
        if (resp.data?.id) {
          return axios.get(`${url}user_collection/getByUser/` + resp.data.id)
            .then(colle => {
              const cols = colle.data || [];
              setCollections(cols);
              setPercollections(cols);
              setSelectedCollection(cols[0] || {
                especimenes_detalle: [],
                bochones_detalle: [],
                especimenes: [],
                bochones: []
              });
              setAllSpecimens(cols.flatMap(collection => collection.especimenes_detalle || []));

            })
            .catch(err => {
              console.error("Error fetching user collections:", err);
              setCollections([]);
              setPercollections([]);
            });
        }

        setCollections([]);
        setPercollections([]);
      })
      .catch(err => {
        console.error("Error fetching user:", err);
      })
      .finally(() => {
        setIsLoadingCollections(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.sub, isAuthenticated]);

  // ----- Build combined list when selectedCollection or sortOrder change -----
  useEffect(() => {
    if (!selectedCollection) {
      setCombinedItems([]);
      return;
    }

    const especimenesArr = selectedCollection?.especimenes_detalle || [];
    const bochonesArr = selectedCollection?.bochones_detalle || [];

    let especMarked = especimenesArr.map(e => ({
      ...e,
      tipo: 'especimen',
      numeroOrden: Number(e.especimennumero || 0),
      sigla: (e.sigla || '').toUpperCase()
    }));
    let bochonMarked = bochonesArr.map(b => ({
      ...b,
      tipo: 'bochon',
      numeroOrden: Number(b.bochonnumero || 0),
      sigla: (b.sigla || '').toUpperCase()
    }));

    const preferredSiglaFirst = sortOrder === 'bochones' ? 'PVBSJ' : 'PVSJ';
    const preferredSiglaSecond = sortOrder === 'bochones' ? 'PVSJ' : 'PVBSJ';

    let all = [...especMarked, ...bochonMarked];

    all.sort((a, b) => {
      const sigA = (a.sigla || '').toUpperCase();
      const sigB = (b.sigla || '').toUpperCase();

      if (sigA === sigB) {
        return Number(a.numeroOrden) - Number(b.numeroOrden);
      }

      const priority = s => (s === preferredSiglaFirst ? 2 : (s === preferredSiglaSecond ? 1 : 0));
      const aPref = priority(sigA);
      const bPref = priority(sigB);
      if (aPref !== bPref) {
        return bPref - aPref;
      }

      if (a.tipo !== b.tipo) {
        if (sortOrder === 'bochones') return a.tipo === 'bochon' ? -1 : 1;
        else return a.tipo === 'especimen' ? -1 : 1;
      }

      return Number(a.numeroOrden) - Number(b.numeroOrden);
    });

    const combined = all.map(x => ({ ...x, tipo: x.tipo || (x.bochonnumero ? 'bochon' : 'especimen') }));
    setCombinedItems(combined);
  }, [selectedCollection, sortOrder]);

  // ----- Handlers -----
  const handleCreateCollection = (name, description, selectedSpecimens, selectedBochones) => {
    const specimenObjects = (allSpecimens || []).filter(specimen =>
      selectedSpecimens.includes(specimen.especimennumero)
    );

    const newCollection = {
      id: Date.now().toString(),
      nombre: name,
      descripcion: description,
      especimenes: selectedSpecimens,
      bochones: selectedBochones,
      especimenes_detalle: specimenObjects,
      bochones_detalle: []
    };

    setCollections(prev => prev ? [...prev, newCollection] : [newCollection]);
    setTimeout(() => { window.location.reload() }, "1000")
  };

  const handleAddSpecimen = (specimen) => {
    const specimenWithImages = {
      ...specimen,
      images: specimen.images && specimen.images.length > 0
        ? specimen.images
        : ["https://images.unsplash.com/photo-1729372463377-ac1adee5090c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxkaW5vc2F1ciUyMGZvc3NpbCUyMHNrZWxldG9ufGVufDF8fHx8MTc1NjIwNDQyNXww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"]
    };


    setSelectedCollection(prev => {
      const prevSpecimens = prev?.especimenes_detalle || [];
      return {
        ...prev,
        especimenes_detalle: [...prevSpecimens, specimenWithImages],
        especimenes: [...(prev?.especimenes || []), specimenWithImages.especimennumero],
      };
    });

    setCollections(prev => prev ? prev.map(collection =>
      collection.id === selectedCollection?.id
        ? {
          ...collection,
          especimenes_detalle: [...(collection.especimenes_detalle || []), specimenWithImages],
          especimenes: [...(collection.especimenes || []), specimenWithImages.especimennumero]
        }
        : collection
    ) : prev);
  };

  const handleRemoveFromCollection = async (item) => {
    if (!selectedCollection?.id) return;
    if (item?.tipo !== 'especimen' && item?.tipo !== 'bochon') return;

    const isSpecimen = item?.tipo === 'especimen';
    const itemId = isSpecimen ? String(item.especimennumero) : String(item.bochonnumero);
    const itemLabel = isSpecimen ? subespecimen(item.especimennumero) : `${(item.sigla || 'PVBSJ').toUpperCase()} ${item.bochonnumero}`;
    const itemTipoLabel = isSpecimen ? 'el espécimen' : 'el bochón';

    const result = await Swal.fire({
      title: "¿Eliminar de la seleccion?",
      html: `Se va a quitar ${itemTipoLabel} <b>${itemLabel}</b> de <b>${selectedCollection.nombre}</b>.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#b91c1c",
      cancelButtonColor: "#6b705c",
      reverseButtons: true
    });

    if (!result.isConfirmed) return;

    const nextSpecimens = (selectedCollection.especimenes || [])
      .map(String)
      .filter((id) => (isSpecimen ? id !== itemId : true))
      .sort((a, b) => Number(b) - Number(a));

    const nextBochones = (selectedCollection.bochones || [])
      .map(String)
      .filter((id) => (!isSpecimen ? id !== itemId : true))
      .sort((a, b) => Number(b) - Number(a));

    const nextSpecimensDetails = (selectedCollection.especimenes_detalle || []).filter(
      (s) => (isSpecimen ? String(s.especimennumero) !== itemId : true)
    );

    const nextBochonesDetails = (selectedCollection.bochones_detalle || []).filter(
      (b) => (!isSpecimen ? String(b.bochonnumero) !== itemId : true)
    );

    const updatedPayload = {
      ...selectedCollection,
      especimenes: nextSpecimens,
      bochones: nextBochones,
    };

    try {
      await axios.put(`${url}user_collection/update/${selectedCollection.id}`, updatedPayload);

      const nextSelected = {
        ...selectedCollection,
        especimenes: nextSpecimens,
        bochones: nextBochones,
        especimenes_detalle: nextSpecimensDetails,
        bochones_detalle: nextBochonesDetails,
      };

      setSelectedCollection(nextSelected);
      setCollections((prev) =>
        (prev || []).map((c) => (String(c.id) === String(selectedCollection.id) ? { ...c, ...nextSelected } : c))
      );
      setPercollections((prev) =>
        (prev || []).map((c) => (String(c.id) === String(selectedCollection.id) ? { ...c, ...nextSelected } : c))
      );

      Swal.fire({
        title: "Eliminado",
        text: "Se quitó el ítem de la colección.",
        icon: "success",
        timer: 1400,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Error removing specimen from collection:", err);
      Swal.fire({
        title: "Error",
        text: "No se pudo actualizar la colección.",
        icon: "error",
      });
    }
  };
  console.log(selectedCollection);

  const handleDeleteSelection = async () => {
    if (!selectedCollection?.id) return;

    const result = await Swal.fire({
      title: t("DELETE_SELECTION_TITLE"),
      html: `${t("DELETE_SELECTION_TEXT")} <b>${selectedCollection?.nombre ?? ""}</b>.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("DELETE_SELECTION_CONFIRM"),
      cancelButtonText: t("CANCEL"),
      confirmButtonColor: "#b91c1c",
      cancelButtonColor: "#6b705c",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    try {
      await axios.delete(`${url}user_collection/delete/${selectedCollection.id}`);

      const nextCollections = (collections || []).filter(
        (c) => String(c.id) !== String(selectedCollection.id)
      );

      setCollections(nextCollections);
      setPercollections(nextCollections);

      setSelectedCollection(
        nextCollections[0] || {
          especimenes_detalle: [],
          bochones_detalle: [],
          especimenes: [],
          bochones: [],
        }
      );

      Swal.fire({
        title: t("DELETE_SELECTION_SUCCESS_TITLE"),
        text: t("DELETE_SELECTION_SUCCESS_TEXT"),
        icon: "success",
        timer: 1400,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Error deleting selection:", err);
      Swal.fire({
        title: t("DELETE_SELECTION_ERROR_TITLE"),
        text: t("DELETE_SELECTION_ERROR_TEXT"),
        icon: "error",
      });
    }
  };

  const handlePrintSelection = async () => {
    if (!selectedCollection?.id) return;

    const fieldDefs = [
      { key: "posicionfilo", label: t("FILOGENETICA") },
      { key: "partesesqueletales", label: t("PARTES_ESQUELETALES") },
      { key: "cuenca", label: t("CUENCA") },
      { key: "formacion", label: t("FORMACION") },
      { key: "miembro", label: t("MIEMBRO") },
      { key: "localidad", label: t("LOCALIDAD") },
      { key: "campana", label: t("CAMPAIGN") },
      { key: "nrocampo", label: t("FIELD") },
      { key: "coord", label: t("COOR") },
      { key: "ubicacion_fisica", label: t("UBICACION_FISICA") },
      { key: "periodo", label: t("PERIODO") },
      { key: "epoca", label: t("EPOCA") },
      { key: "piso", label: t("PISO") },
      { key: "descubridor", label: t("DESCUBRIDOR") },
      { key: "fechadescubrimiento", label: t("FECHACAM") },
      { key: "preparador", label: t("PREPARADOR") },
      { key: "preparacionfecha", label: t("FECHAPRE") },
      { key: "cantidadfrag", label: t("FRAGMENTOS") },
      { key: "estado", label: t("ESTADO") },
      { key: "comentario", label: t("COMENT") },
    ];

    const defaultKeys = new Set([
      "formacion",
      "cuenca",
      "localidad",
      "campana",
      "nrocampo",
      "periodo",
      "epoca",
    ]);

    const checkboxHtml = `
      <div style="text-align:left; display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:10px; margin-top:8px;">
        ${fieldDefs
          .map(
            (f) => `
          <label style="display:flex; align-items:center; gap:8px; font-size:14px; line-height:1.2;">
            <input type="checkbox" name="printField" value="${f.key}" ${defaultKeys.has(f.key) ? "checked" : ""} />
            <span>${f.label}</span>
          </label>
        `
          )
          .join("")}
      </div>
    `;

    const result = await Swal.fire({
      title: t("PRINT_SELECTION_TITLE"),
      html: `<div style="text-align:left; margin-bottom:10px;">${t("PRINT_SELECTION_SUBTITLE")}</div>${checkboxHtml}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("PRINT_SELECTION_CONFIRM"),
      cancelButtonText: t("CANCEL"),
      confirmButtonColor: "#2f5a4a",
      cancelButtonColor: "#6b705c",
      reverseButtons: true,
      preConfirm: () => {
        const checked = Array.from(document.querySelectorAll('input[name="printField"]:checked')).map(
          (el) => el.value
        );
        if (checked.length === 0) {
          Swal.showValidationMessage(t("PRINT_SELECTION_VALIDATION"));
          return null;
        }
        return checked;
      },
    });

    if (!result.isConfirmed || !Array.isArray(result.value)) return;

    const selectedKeys = new Set(result.value);
    const enabledFields = fieldDefs.filter((f) => selectedKeys.has(f.key));

    const getValue = (item, key) => {
      if (key === "coord") {
        const lat = item?.coordlat;
        const lng = item?.coordlong;
        if (lat === undefined || lat === null || lat === "" || lng === undefined || lng === null || lng === "") return "";
        return `${lat} / ${lng}`;
      }
      if (key === "ubicacion_fisica") {
        const a1 = item?.armario1;
        const d1 = item?.estante1desde;
        const h1 = item?.estante1hasta;
        const a2 = item?.armario2;
        const d2 = item?.estante2desde;
        const h2 = item?.estante2hasta;

        const parts = [];
        if (a1 !== undefined && a1 !== null && a1 !== "") {
          parts.push(`${t("ARMARIO")} 1: ${a1}${d1 !== undefined && h1 !== undefined ? ` [${d1}-${h1}]` : ""}`);
        }
        if (a2 !== undefined && a2 !== null && a2 !== "") {
          parts.push(`${t("ARMARIO")} 2: ${a2}${d2 !== undefined && h2 !== undefined ? ` [${d2}-${h2}]` : ""}`);
        }
        return parts.join(" | ");
      }
      const v = item?.[key];
      if (Array.isArray(v)) return v.join(", ");
      return v ?? "";
    };

    const toText = (v) => {
      if (v === null || v === undefined) return "";
      const s = String(v).trim();
      if (!s || s.toLowerCase() === "null" || s.toLowerCase() === "undefined") return "";
      return s;
    };

    const safeName = (name) =>
      String(name || "seleccion")
        .replace(/[\\/:*?"<>|]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const doc = new jsPDF();
    const marginX = 10;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const contentWidth = pageWidth - marginX * 2;

    doc.addImage(logoMuseo, 10, 10, 60, 25);
    doc.setFontSize(12);
    doc.text(t("PDF_INSTITUTE"), marginX + 55, 14);
    doc.setFontSize(10);
    doc.text(t("PDF_CATALOG"), marginX + 55, 19);
    doc.setFontSize(10);
    doc.text(t("PDF_DATE"), pageWidth - marginX - 20, 18);
    doc.setFont("verdana", "bold");
    doc.text(fechaActual(), pageWidth - marginX - 22, 23);
    doc.setFont(undefined, "normal");
    doc.rect(70, 23, 90, 10);

    doc.setFontSize(11);
    doc.setFont("impact", "bold");
    doc.text(`${t("PRINT_SELECTION_PDF_HEADER")}: ${selectedCollection?.nombre ?? ""}`, marginX, 34);
    doc.setFont(undefined, "normal");
    doc.setFontSize(9);
    doc.text(`${t("PRINT_SELECTION_PDF_ITEMS")}: ${(combinedItems?.length ?? 0)}`, marginX, 40);
    doc.line(marginX, 44, pageWidth - marginX, 44);

    let y = 52;

    (combinedItems || []).forEach((item, idx) => {
      const isSpecimen = item?.tipo === "especimen" || !!item?.especimennumero;
      const code = isSpecimen
        ? `PVSJ ${subespecimen(item?.especimennumero)}`
        : `${(item?.sigla || "PVBSJ").toUpperCase()} ${item?.bochonnumero}`;

      const genus = toText(item?.genero);
      const species = toText(item?.especie);
      const sci = [genus, species].filter(Boolean).join(" ");

      const headerLine = `${idx + 1}. ${code}${sci ? ` - ${sci}` : ""}`;

      const headerLines = doc.splitTextToSize(headerLine, contentWidth);
      const requiredHeaderHeight = headerLines.length * 4 + 2;
      if (y + requiredHeaderHeight > pageHeight - 12) {
        doc.addPage();
        y = 20;
      }

      doc.setFontSize(9);
      doc.setFont(undefined, "bold");
      doc.text(headerLines, marginX, y);
      y += headerLines.length * 4 + 2;

    doc.setFontSize(8);
    doc.setFont(undefined, "normal");

      const WIDE_KEYS = new Set([
        "partesesqueletales",
        "posicionfilo",
        "coord",
        "ubicacion_fisica",
        "comentario",
      ]);

      const ensureSpace = (neededHeight) => {
        if (y + neededHeight > pageHeight - 12) {
          doc.addPage();
          y = 20;
        }
      };

      const renderRow = (rowFields) => {
        if (!rowFields?.length) return;

        const gap = 6;
        const cols = rowFields.length;
        const colWidth = cols === 2 ? (contentWidth - gap) / 2 : contentWidth;
        const xPositions = cols === 2 ? [marginX, marginX + colWidth + gap] : [marginX];

        const cellLines = rowFields.map((f) => {
          const value = toText(getValue(item, f.key));
          const text = `${f.label}: ${value}`;
          return doc.splitTextToSize(text, colWidth);
        });

        const maxLines = Math.max(...cellLines.map((ls) => ls.length));
        const rowHeight = Math.max(1, maxLines) * 4;

        ensureSpace(rowHeight);

        cellLines.forEach((lines, i) => {
          doc.text(lines, xPositions[i], y);
        });

        y += rowHeight;
      };

      const filteredFields = enabledFields
        .map((field) => ({ field, value: toText(getValue(item, field.key)) }))
        .filter((x) => !!x.value);

      let row = [];
      filteredFields.forEach(({ field }) => {
        const isWide = WIDE_KEYS.has(field.key);

        if (isWide) {
          renderRow(row);
          row = [];
          renderRow([field]);
          return;
        }

        row.push(field);
        if (row.length === 2) {
          renderRow(row);
          row = [];
        }
      });
      renderRow(row);

      y += 2;
      if (y < pageHeight - 12) {
        doc.setDrawColor(210);
        doc.line(marginX, y, pageWidth - marginX, y);
        doc.setDrawColor(0);
      }
      y += 6;
    });

    doc.save(`${fechaActual()} - ${safeName(selectedCollection?.nombre)}.pdf`);
  };

  // ----- Render -----
  return (
    <div>
      <Menu activo={5} />
      <div className={styles.container}>
        <div className={styles.maxWidth}>



          {/* Main Header */}
          <div className={styles.header}>
            <h1 className={styles.title}>{t("MY_SELECTIONS")}</h1>
            <button
              className={styles.createButton}
              onClick={() => setCreateCollectionOpen(true)}
            >
              <Plus className="w-4 h-4 mr-2" />
              {t("CREATE_COLLECTION_BUTTON")}
            </button>
          </div>

          {/* no collections / collections list */}
          {isLoadingCollections ? (
            <LoadingState message={t("LOADING")} minHeight={420} />
          ) : percollections?.length === 0 || percollections === null ? (
            <h1 className={styles.title}></h1>
          ) : (
            <div>

              {/* Collection Selector */}


              <Card className={styles.collectionSelector}>
                <CardHeader className="pb-4" style={{ display: 'none' }}>
                  <CardTitle className={styles.collectionTitle}>
                    <Archive className="w-5 h-5 text-primary" />
                    Your Collections
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className={styles.collectionsGrid}>
                    {(collections?.length > 0) ? (
                      collections.map((collection) => (
                        <Button
                          key={collection.id}
                          variant={selectedCollection?.id === collection.id ? "default" : "outline"}
                          onClick={() => setSelectedCollection(collection)}
                          className={`${styles.collectionButton} ${selectedCollection?.id === collection.id
                            ? styles.collectionButtonActive
                            : styles.collectionButtonInactive
                            }`}
                        >
                          <span className={styles.collectionName}>{collection.nombre}</span>
                          <span className={styles.collectionCount}>
                            {Array.isArray(collection.especimenes) ? collection.especimenes.length + collection.bochones.length : (collection.especimenes?.length ?? 0)} ítems
                          </span>
                        </Button>
                      ))
                    ) : (
                      (
                        <Button
                          key={collections[0].id}
                          variant={selectedCollection?.id === collections[0].id ? "default" : "outline"}
                          onClick={() => setSelectedCollection(collections[0])}
                          className={`${styles.collectionButton} ${selectedCollection?.id === collections[0].id
                            ? styles.collectionButtonActive
                            : styles.collectionButtonInactive
                            }`}
                        >
                          <span className={styles.collectionName}>{collections[0].nombre}</span>
                          <span className={styles.collectionCount}>
                            {(
                              (collections[0].especimenes?.length ?? 0) +
                              (collections[0].bochones?.length ?? 0)
                            )} ítems
                          </span>
                        </Button>
                      )
                    )}
                  </div>
                </CardContent>
              </Card>

              {/* Selected Collection Details */}
              <Card className={styles.collectionDetails}>
                <CardHeader className="pb-4">
                  <div className={styles.collectionDetailsHeader}>
                    <div className={styles.collectionInfo}>
                      <CardTitle className={styles.collectionDetailsTitle}>
                        {selectedCollection?.nombre}
                      </CardTitle>
                      <p className={styles.collectionDescription}>
                        {selectedCollection?.descripcion}
                      </p>
                    </div>

                    <div className={styles.collectionStats}>
                      <Badge variant="secondary" className={styles.statBadge}>
                        <Beaker className="w-3 h-3" />
                        {(selectedCollection?.especimenes?.length ?? 0)} especímenes
                      </Badge>
                      <Badge variant="secondary" className={styles.statBadgeAlt}>
                        <Archive className="w-3 h-3" />
                        {(selectedCollection?.bochones?.length ?? 0)} bochones
                      </Badge>
                      <button
                        type="button"
                        className={styles.printSelectionButton}
                        onClick={handlePrintSelection}
                        title={t("PRINT_SELECTION_BUTTON")}
                      >
                        <Printer className="w-4 h-4" />
                        <span className={styles.printSelectionLabel}>{t("PRINT_SELECTION_BUTTON")}</span>
                      </button>
                      <button
                        type="button"
                        className={styles.deleteSelectionButton}
                        onClick={handleDeleteSelection}
                        title={t("DELETE_SELECTION_BUTTON")}
                      >
                        <Trash2 className="w-4 h-4" />
                        <span className={styles.deleteSelectionLabel}>{t("DELETE_SELECTION_BUTTON")}</span>
                      </button>
                    </div>
                  </div>
                </CardHeader>
              </Card>

              {/* Specimens Section */}
              <div className="space-y-4">
                <div className={styles.specimensHeader}>
                  <h2 className={styles.specimensTitle}>{t("SPECIMENS")}</h2>

                  <div className={styles.specimensControls}>
                    <div className={styles.viewToggle}>
                      <button
                        onClick={() => setViewLayout('grid')}
                        className={`${styles.viewButton} ${viewLayout === 'grid' ? styles.viewButtonActive : ''}`}
                      >
                        <Grid3X3 className="w-4 h-4" />
                      </button>

                      <button
                        onClick={() => setViewLayout('list')}
                        className={`${styles.viewButton} ${viewLayout === 'list' ? styles.viewButtonActive : ''}`}
                      >
                        <List className="w-4 h-4" />
                      </button>
                    </div>

                    {selectedCollection?.bochones?.length > 0 && (
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setSortOrder(sortOrder === 'bochones' ? 'especimenes' : 'bochones')}
                        className={styles.sortButton}
                        title={sortOrder === 'bochones' ? 'Bochones primero' : 'Especimenes primero'}
                      >
                        <span className={styles.sortLabel}>
                          {sortOrder === 'bochones' ? 'PVBSJ primero' : 'PVSJ primero'}
                        </span>
                      </Button>
                    )}

                    <Button
                      className={styles.addSpecimenButton}
                      onClick={() => setAddSpecimenOpen(true)}
                    >
                      <Plus className="w-4 h-4 mr-2" />
                      Agregar
                    </Button>
                  </div>
                </div>
              </div>

              {/* Items grid / list */}
              <div className={viewLayout === 'list' ? styles.specimensGridList : styles.specimensGrid}>
                {combinedItems.map((item) => (
                  <div
                    key={item.especimennumero || item.bochonnumero || `${item.tipo}-${item.numeroOrden}`}
                  >
                    <SpecimenCard specimen={item} layout={viewLayout} onRemoveFromCollection={handleRemoveFromCollection} />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Empty state */}
          {!isLoadingCollections && (combinedItems?.length ?? 0) === 0 && (
            <Card className={styles.emptyState}>
              <CardContent className="flex flex-col items-center text-center p-8 space-y-4">
                <Beaker className={styles.emptyStateIcon} />
                <h3 className={styles.emptyStateTitle}>
                  {t("NO_SPECIMENS_TITLE")}
                </h3>
                <p className={styles.emptyStateDescription}>
                  {selectedCollection
                    ? t("NO_SPECIMENS_DESCRIPTION")
                    : t("NO_COLLECTION_DESCRIPTION")}
                </p>

                {!selectedCollection && (
                  <Button
                    className={styles.createButton}
                    onClick={() => setCreateCollectionOpen(true)}
                  >
                    {t("CREATE_COLLECTION_BUTTON")}
                  </Button>
                )}
              </CardContent>
            </Card>
          )}

          {/* Modals */}
          {/* Modal Unificado */}
          <CreateCollectionModal
            open={createCollectionOpen || addSpecimenOpen}
            onOpenChange={(state) => {
              // Si se cierra, cerramos ambos
              if (!state) {
                setCreateCollectionOpen(false);
                setAddSpecimenOpen(false);
              }
            }}
            mode={createCollectionOpen ? "create" : "add"} // Detecta qué modal era
            availableSpecimens={espec}
            availableBochones={bochon}
            usuarioid={users?.id}
            collectionSelect={selectedCollection}
            setCollection={setSelectedCollection}
            onCreateCollection={handleCreateCollection}
            onAddSpecimen={handleAddSpecimen}
          />

          {/*  <AddSpecimenModal
            open={addSpecimenOpen}
            onOpenChange={setAddSpecimenOpen}
            availableSpecimens={espec}
            availableBochones={bochon}
            usuarioid={users?.id}
            onAddSpecimen={handleAddSpecimen}
            collectionSelect={selectedCollection}
            setCollection={setSelectedCollection}
            mode="add"
          />
 */}
        </div>
      </div>
    </div>
  );
}
